import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'uia-ui-absolute',
  template: `
    <p>
      ui-absolute works!
    </p>
  `,
  styles: []
})
export class UiAbsoluteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
